import { render } from "./LoginActualizarClave.vue?vue&type=template&id=2feaade6&scoped=true"
import script from "./LoginActualizarClave.vue?vue&type=script&lang=js"
export * from "./LoginActualizarClave.vue?vue&type=script&lang=js"

import "./LoginActualizarClave.vue?vue&type=style&index=0&id=2feaade6&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2feaade6"]])

export default __exports__